import React from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Logo from "@/components/Logo";
import Footer from "@/components/Footer";
import { LEGAL_DOCS } from "@/data/legal";

export default function Legal() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const doc = LEGAL_DOCS[slug];

  return (
    <div style={{ background: "var(--af-black)", minHeight: "100vh" }}>
      <div className="sticky top-0 z-40" style={{ background: "rgba(13,13,13,0.95)", backdropFilter: "blur(12px)", borderBottom: "1px solid var(--af-border-dark)" }}>
        <div className="af-container flex items-center gap-3" style={{ height: 68 }}>
          <button data-testid="legal-back" onClick={() => navigate(-1)} className="text-white/80 hover:text-af-orange-core"><ArrowLeft size={22} /></button>
          <Link to="/"><Logo height={40} /></Link>
        </div>
      </div>

      <div className="af-container py-10 md:py-14 max-w-3xl" data-testid={`legal-${slug}`}>
        {!doc ? (
          <div className="af-card p-10 text-center">
            <h1 className="h-impact text-white text-2xl">Documento no encontrado</h1>
            <Link to="/" className="af-btn-primary mt-6 inline-flex">Volver al inicio</Link>
          </div>
        ) : (
          <>
            <h1 className="h-impact text-white text-3xl md:text-4xl">{doc.title}</h1>
            <p className="text-white/50 text-sm mt-2 mb-8">{doc.subtitle}</p>
            <div className="space-y-5">
              {doc.blocks.map((b, i) => (
                <div key={i}>
                  {b.h && <h2 className="text-af-orange-core font-display uppercase font-semibold text-lg mt-8 mb-2">{b.h}</h2>}
                  {b.sh && <h3 className="text-white font-semibold mt-4">{b.sh}</h3>}
                  {b.p && <p className="text-white/70 text-sm leading-relaxed mt-1">{b.p}</p>}
                </div>
              ))}
            </div>
            <div className="mt-10 flex flex-wrap gap-3 text-sm">
              <Link to="/legal/terminos" className="text-white/60 hover:text-af-orange-core">Términos y Condiciones</Link>
              <span className="text-white/20">·</span>
              <Link to="/legal/privacidad" className="text-white/60 hover:text-af-orange-core">Aviso de Privacidad Integral</Link>
              <span className="text-white/20">·</span>
              <Link to="/legal/cookies" className="text-white/60 hover:text-af-orange-core">Política de Cookies</Link>
            </div>
          </>
        )}
      </div>
      <Footer />
    </div>
  );
}
